import React from 'react';
import { Link } from 'react-router-dom';

const MyCustomAlgoRequests = () => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-[24px] font-bold text-white mb-1">My Custom Algo Requests</h1>
          <p className="text-[14px] text-on-surface-variant">
            Track your custom algorithm development projects, quotes, and progress.
          </p>
        </div>
        <Link to="/custom-ea" className="bg-primary text-[#131418] font-bold px-6 py-3 rounded-full text-[14px] hover:shadow-[0_0_15px_rgba(240,185,11,0.4)] hover:-translate-y-0.5 transition-all duration-300 whitespace-nowrap">
          Submit New Strategy
        </Link>
      </div>

      <div className="bg-surface-container border border-white/5 rounded-3xl p-16 text-center flex flex-col items-center justify-center shadow-lg">
        <div className="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center mb-6 border border-white/10">
          <span className="material-symbols-outlined text-[32px] text-[#4285F4]">laptop_mac</span>
        </div>
        
        <h2 className="text-[20px] font-bold text-white mb-2">No Custom Algo Projects Yet</h2>
        <p className="text-[14px] text-on-surface-variant mb-8 max-w-md">
          Have a unique trading strategy? Tell us about it and we'll build a custom EA for you.
        </p>
        
        <Link to="/custom-ea" className="border border-white/20 text-white font-bold px-8 py-3 rounded-full text-[14px] hover:bg-white/5 hover:border-white/40 transition-all duration-300">
          Request Custom Algo
        </Link>
      </div>
    </div>
  );
};

export default MyCustomAlgoRequests;
